/**
 * Exceção "chance de validar o mês anterior" (Douglas 03/11/2026, Regras do
 * sistema aprovadas em 04/11/2026).
 *
 * "Iríamos dar uma chance do funcionário bater a sua meta deste mês e fazer o
 * a mais que está faltando... assim ele pode validar no máximo 50%, que é a
 * regra 3, mas somente se a meta dele deste mês for atingida."
 *
 * Nenhum pedido muda de mês. A prova (meta normal do mês seguinte × N + o que
 * faltou) mora no banco, em `fn_regra_excecao_prova`; os motores só recebem o
 * fator de quem validou (`fn_regra_excecao_fatores`). Quem já bateu o mês fica
 * como está; quem validou pela exceção paga o teto (50%). Os descontos
 * (convergência, deflator, eSIM) seguem iguais, sobre o que ela paga.
 *
 * Régua única dos três motores (tela, folha e Excel).
 */
export function aplicarExcecaoMesAnterior(p: {
  bateuMeta: boolean;
  fator: number;
  /** Fator da exceção para esta pessoa no mês (0,5), ou nulo se não validou. */
  fatorExcecao?: number | null;
}): { bateuMeta: boolean; fator: number; porExcecao: boolean } {
  const f = Number(p.fatorExcecao);
  if (p.bateuMeta || !Number.isFinite(f) || f <= 0) {
    return { bateuMeta: p.bateuMeta, fator: p.fator, porExcecao: false };
  }
  return { bateuMeta: true, fator: Math.min(1, f), porExcecao: true };
}

/** Mapa usuário → fator, a partir das linhas de `fn_regra_excecao_fatores`. */
export function mapaFatoresExcecao(linhas: Array<{ usuario_id: string; fator: number | string }> | null | undefined): Map<string, number> {
  const m = new Map<string, number>();
  for (const l of linhas || []) {
    const f = Number(l.fator);
    if (l.usuario_id && Number.isFinite(f) && f > 0) m.set(l.usuario_id, f);
  }
  return m;
}
